module.exports = __webpack_public_path__ + "static/media/052.a867715a.jpg";